export default ['Brooklyn', 'Manhattan', 'Queens'];



// WEBPACK FOOTER //
// ./src/constants/Regions.js